@if (total !== null && total > 0) {
    <div class="d-flex align-items-center justify-content-center">
        <!-- Prev -->
        @if (canGoPrevPage) {
            <a [routerLink]="['..', prevPageNumber]" queryParamsHandling="merge" class="arrow arrow-prev p-4 ms-1">
                <span></span>
            </a>
        } @else {
            <span class="arrow arrow-prev arrow-disabled p-4 ms-1"><span></span></span>
        }
        <!-- Current -->
        {{ 'PRODUCTS.pagination.pages.page' | translate }}
        <span class="border border-gray-200 rounded-3 px-3 py-2 mx-2">{{ currentPage$ | async }}</span>
        {{ 'PRODUCTS.pagination.pages.of' | translate }}
        <span class="ms-2">{{ totalPages }}</span>
        <!-- Next -->
        @if (canGoNextPage) {
            <a class="arrow arrow-next p-4 ms-1" [routerLink]="['..', nextPageNumber]" queryParamsHandling="merge">
                <span></span>
            </a>
        } @else {
            <span class="arrow arrow-next arrow-disabled p-4 ms-1"><span></span></span>
        }
    </div>
}
